import Choices from "choices.js";
import Swiper from "swiper";

export default class Global {

    constructor() {
        this.initChoices();
        this.initReviews();
        this.initPopup();
    }

    initPopup(){
        if(document.getElementById("holidayPopup") === null) return;
        const setCookie = (name, value, days) => {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = `${name}=${value}; ${expires}; path=/`;
        };

        const getCookie = (name) => {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        };

        const popup = document.getElementById("holidayPopup");
        const overlay = document.getElementById("holidayPopupOverlay");
        const closeBtn = document.getElementById("holidayPopupClose");

        const closePopup = () => {
            popup.style.display = "none";
            overlay.style.display = "none";
            setCookie("hidePopup2024", "true", 1);
        };

        if (getCookie("hidePopup2024") === "true") {
            popup.style.display = "none";
            overlay.style.display = "none";
        } else {
            closeBtn.addEventListener("click", closePopup);
            overlay.addEventListener("click", closePopup);
        }
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }


    initReviews() {
        if(document.querySelectorAll('#reviewSlider') !== null){
            new Swiper('#reviewSlider .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop:true,
                autoplay: {
                    delay: 3500,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 2,
                    }
                }
            });
        }
    }
}
